const React = require('react')
const { StylesProvider, createGenerateClassName } = require('@mui/styles')

// gatsby-ssr.js と同じ理由でJSXは使わない（root直下のgatsby-*.jsはbabel変換無しで
// require()されうるため、プレーンなReact.createElementで書く）。
exports.wrapRootElement = ({ element }) => {
  const generateClassName = createGenerateClassName()
  return React.createElement(StylesProvider, { generateClassName }, element)
}
